// extracted by mini-css-extract-plugin
export default {"wrapperSp":"Spinner_style_wrapperSp__60g+M","spinner1":"Spinner_style_spinner1__U4Kd5","spin":"Spinner_style_spin__t4tdw","rotate":"Spinner_style_rotate__Ujcu9"};